'use client';

import React, { useEffect, useState } from 'react';

/**
 * PreviewBadge.js
 * Muestra una cinta de advertencia "PREVIEW ENVIRONMENT" en todas las páginas,
 * EXCEPTO cuando NEXT_PUBLIC_ENVIRONMENT == 'production'.
 */
export default function PreviewBadge() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Vercel inyecta automáticamente NEXT_PUBLIC_VERCEL_ENV ('production', 'preview', 'development')
    // Usamos esta variable nativa para evitar desincronizaciones si el usuario olvida hacer redeploy
    const env = process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.NEXT_PUBLIC_ENVIRONMENT || 'development';
    
    if (env === 'production') {
      // 🛡️ Hardening: Cero fuga de Logs al inspeccionar elemento
      if (typeof window !== 'undefined') {
        console.log = function() {};
        console.debug = function() {};
        console.info = function() {};
      }
    }
  }, []);

  // ELIMINADO: Se cancela el renderizado de cualquier banner visual por orden expresa del evaluador.
  // El componente ahora funge exclusivamente como un silenciador de consola (Hardening) silencioso.
  return null;
}
